"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _modelPropTypes = _interopRequireDefault(require("./modelPropTypes"));
var _Card = _interopRequireDefault(require("./Card"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var CardContainer = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  :hover {\n    background: ", ";\n  }\n"])), function (props) {
  return props.hoverColour;
});
var ResponsiveCardsRow = function ResponsiveCardsRow(props) {
  var CardClass = props.CardClass,
    cards = props.cards;
  var className = props.className,
    cardContainerClassName = props.cardContainerClassName,
    speciesIconHeight = props.speciesIconHeight,
    imageIconHeight = props.imageIconHeight,
    hoverColour = props.hoverColour;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: className
  }, Array.isArray(cards) && cards.map(function (card, index) {
    return /*#__PURE__*/_react["default"].createElement(CardContainer, {
      hoverColour: hoverColour,
      className: cardContainerClassName,
      key: index
    }, /*#__PURE__*/_react["default"].createElement(CardClass, _extends({}, card, {
      imageIconHeight: imageIconHeight,
      speciesIconHeight: speciesIconHeight
    })));
  }));
};
ResponsiveCardsRow.propTypes = {
  cards: _propTypes["default"].arrayOf(_propTypes["default"].shape(_modelPropTypes["default"])).isRequired,
  CardClass: _propTypes["default"].func,
  className: _propTypes["default"].string,
  cardContainerClassName: _propTypes["default"].string,
  speciesIconHeight: _propTypes["default"].string,
  imageIconHeight: _propTypes["default"].string,
  hoverColour: _propTypes["default"].string
};
ResponsiveCardsRow.defaultProps = {
  CardClass: _Card["default"],
  className: "",
  cardContainerClassName: "",
  speciesIconHeight: "6rem",
  imageIconHeight: "2rem",
  hoverColour: "AliceBlue"
};
var _default = exports["default"] = ResponsiveCardsRow;